export const SCENE_CHANGED = 'SCENE_CHANGED';
export const INTRO_CLOSED = 'INTRO_CLOSED';
export const VIEW_CHANGED = 'VIEW_CHANGED';
export const MEDIA_PREVIEW_OPENED = 'MEDIA_PREVIEW_OPENED';
export const MEDIA_PREVIEW_CLOSED = 'MEDIA_PREVIEW_CLOSED';
export const CHAT_STARTED = 'CHAT_STARTED';
export const FIRST_VISIT_SCHENE = 'FIRST_VISIT_SCHENE';